export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel['trace'] = 0] = 'trace'
    LogLevel[LogLevel['debug'] = 1] = 'debug'
    LogLevel[LogLevel['log'] = 2] = 'log'
    LogLevel[LogLevel['info'] = 3] = 'info'
    LogLevel[LogLevel['warn'] = 4] = 'warn'
    LogLevel[LogLevel['error'] = 5] = 'error'
    LogLevel[LogLevel['silent'] = 6] = 'silent'
})(LogLevel || (LogLevel = {}))
